import React, { useState } from "react";
import ConfirmPasswordModal from "./ConfirmPasswordModal";

const ClientTable = ({ clients, selectedUsers, toggleUserSelection, toggleSelectAll, editClient, deleteClient }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  // ✅ Open ConfirmPasswordModal when delete is triggered
  const handleDelete = (userId) => {
    setSelectedClient(userId);
    setShowConfirmModal(true);
  };

  // ✅ Execute delete after confirmation
  const confirmDelete = async () => {
    if (selectedClient) {
      await deleteClient(selectedClient);
      setSelectedClient(null);
      setShowConfirmModal(false);
    }
  };

  return (
    <div className="browse_client_table_body">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>
              <label className="cl-checkbox">
                <input
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={selectedUsers.length === clients.length && clients.length > 0}
                />
                <span></span>
              </label>
            </th>
            <th>Name</th>
            <th>Email</th>
            <th>Company</th>
            <th>Created</th>
            <th>Manage</th>
          </tr>
        </thead>
        <tbody>
          {clients.length > 0 ? (
            clients.map((client) => (
              <tr key={client.user_id}>
                <td>
                  <label className="cl-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedUsers.includes(client.user_id)}
                      onChange={() => toggleUserSelection(client.user_id)}
                    />
                    <span></span>
                  </label>
                </td>
                <td>{client.user_name}</td>
                <td>{client.user_email}</td>
                <td>{client.user_company}</td>
                <td>
                  {client.user_created
                    ? new Date(client.user_created).toISOString().split("T")[0].replace(/-/g, "/")
                    : "N/A"}
                </td>
                <td>
                  <div className="share_dtls_btn_holder">
                    <button
                      type="button"
                      className="rounded_action"
                      onClick={() => editClient(client.user_id)}
                    >
                      <span><i className="fa-solid fa-user-pen"></i></span>
                    </button>
                    <button
                      type="button"
                      className="rounded_action"
                      onClick={() => handleDelete(client.user_id)} // ✅ Trigger delete confirmation
                    >
                      <span><i className="fa-solid fa-user-minus"></i></span>
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center", padding: "10px" }}>
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* ✅ Confirm Password Modal */}
      <ConfirmPasswordModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onSuccess={confirmDelete}
      />
    </div>
  );
};

export default ClientTable;
